<template>
  <div>
    <div v-if="editing">
      <div class="input-group mb-3">
        <input type="text" class="form-control" v-model="newContactName" @blur="saveContact" v-on:keyup.enter="saveContact" placeholder='Name'>
        <div class="input-group-append">
          <button class="btn btn-primary" type="button" @click="saveContact">Save</button>
        </div>
      </div>
    </div>
    <span v-else>
      <i class="material-icons pointer x-small-icon" data-toggle="dropdown">edit</i>
      <div class="dropdown-menu dropdown-menu-left">
        <a v-if="!this.contact.discarded_at" class="dropdown-item text-primary" href="#" @mousedown="focus">Edit</a>
        <a v-if="isArchived()" class="pointer dropdown-item text-danger"  @click="unarchiveContact()">Unarchive {{ $t("contacts.singular") }}</a>
        <a v-else class="dropdown-item text-danger" href="#" data-toggle="modal" :data-target="'#archiveModal' + contact.id">Archive {{ $t("contacts.singular") }}</a>
        <a v-if="isTrashed()" class="pointer dropdown-item text-danger"  @click="untrashContact()">Remove from Trash</a>
        <a v-else class="dropdown-item text-danger" href="#" data-toggle="modal" :data-target="'#trashModal' + this.contact.id">Trash {{ $t("contacts.singular") }}</a>
      </div>
      <div class="modal fade" :id="'archiveModal' + this.contact.id">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Are you sure you want to {{ actionName.toLowerCase() }} this assistant?</h5>
              </div>
              <div class="modal-body">
                <div> Are you sure you want to {{ actionName.toLowerCase() }}
                  <em>
                    {{this.contact.name}}
                  </em>
                  ?
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button v-if="this.contact.discarded_at" type="button" class="btn btn-primary" @click="restoreContact()">{{ actionName }} Assistant</button>
                <button v-else type="button" class="btn btn-primary" @click="archiveContact()">{{ actionName }} Assistant</button>
              </div>
            </div>
          </div>
      </div>
      <div class="modal fade" :id="'trashModal' + this.contact.id">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Are you sure you want to {{ trashActionName.toLowerCase() }} this {{ $t("contacts.singular").toLowerCase() }}?</h5>
              </div>
              <div class="modal-body">
                <div> Are you sure you want to {{ trashActionName.toLowerCase() }}
                  <em>
                    {{this.contact.name}}
                  </em>
                  ?
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button v-if="this.contact.archived_at" type="button" class="btn btn-primary" @click="unarchiveTrash()">{{ trashActionName }} {{ $t("contacts.singular") }}</button>
                <button v-else type="button" class="btn btn-primary" @click="trashContact()">{{ trashActionName }} {{ $t("contacts.singular") }}</button>
              </div>
            </div>
          </div>
      </div>
      <router-link :to="{ name: 'contact', params: { contact_id: this.contact.id } }" class="text-secondary">
        {{this.contact.name}} <i v-if="contact.deleted_at" class="material-icons x-small-icon">delete</i>
      </router-link>
    </span>
  </div>
</template>

<script>
import api from "api";

export default {
  components: {
  },
  props: {
    contact: Object
  },
  data() {
    return {
      editing: false,
      newContactName: this.contact.name
    };
  },
  computed: {
    archived_at: function() {
      return new Date()
    },
    actionName: function () {
      return this.contact.discarded_at === null ? 'Archive' : 'Unarchive'
    },
    trashActionName: function () {
      return this.contact.deleted_at === null ? 'Trash' : 'Untrash'
    }, 
  },
  created() {
   this.originalContactName = this.contactName
  },
  methods: {
    isArchived(){
      return this.contact.discarded_at
    },
    isTrashed(){
      return this.contact.deleted_at
    },     
    saveContact(){
      this.editing = false;
      api.updateContact(this.contact.id, this.newContactName).then(response => {
      });
    },
    archiveContact(){
      this.editing = false;
      var contactId = this.contact.id
      $('#archiveModal' + contactId).modal('hide')
      api.archiveContact(contactId).then(response => {
        store.commit('removeIdFromSortedGroup', { name: 'contacts', id: contactId })
        store.commit('addIdToSortedGroup', { name: 'archived_contacts', id: contactId })
      });
    },
    unarchiveContact(){
      this.editing = false;
      var contactId = this.contact.id
      $('#archiveModal' + contactId).modal('hide')
      api.unarchiveContact(contactId).then(response => {
        store.commit('addIdToSortedGroup', { name: 'contacts', id: contactId })
        store.commit('removeIdFromSortedGroup', { name: 'archived_contacts', id: contactId })
      });
    },
    focus(event){
      this.editing = true;
    },
    trashContact() {
      this.editing = false;
      var contactId = this.contact.id
      $('#trashModal' + this.contact.id).modal('hide')
      api.trashContact(this.contact.id).then(response => {
        store.commit('removeIdFromSortedGroup', { name: 'contacts', id: contactId })
        store.commit('addIdToSortedGroup', { name: 'archived_contacts', id: contactId })
      });
    },
    untrashContact() {
      this.editing = false;
      var contactId = this.contact.id
      $('#trashModal' + this.contact.id).modal('hide')
      api.untrashContact(this.contact.id).then(response => {
        store.commit('addIdToSortedGroup', { name: 'contacts', id: contactId })
        store.commit('removeIdFromSortedGroup', { name: 'archived_contacts', id: contactId })
      });
    },
  }
}
</script>
